<div class="padding bg-light-grey">
	<div class="flex center">
		<span class="flex center primary hover margin-right" [routerLink]="['/templates']">
			<i class="fa-solid fa-arrow-left margin-right-small"></i>
			Back
		</span>

		Templates
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		Create Template
	</div>
</div>

<div class="page-layout padding">
	<div class="flex between center">
		@if (template) {
		<h4>Edit template</h4>
		} @else {
		<h4>New template</h4>
		}

		<div class="flex column end">
			<div class="flex center">
				<button class="stroked margin-right-small" (click)="cancel()">
					<i class="fa-solid fa-undo"></i>
					Discard changes
				</button>
				<button (click)="confirm()">
					<i class="fa-solid fa-save"></i>
					Save Changes
				</button>
			</div>
		</div>
	</div>

	@if (template) {
	<div class="flex column margin-top">
		<span class="bold margin-bottom-small">Name:</span>
		<span>{{ template.templateName }}</span>
	</div>
	}

	<form class="margin-top">
		<span class="bold">Products:</span>
		<div class="border padding margin-top-small margin-bottom">
			<div class="flex center">
				<div class="flex-1 flex column margin-right-small">
					<span class="bold margin-bottom-small">Brand</span>
					<mat-form-field appearance="outline">
						<mat-select
							name="brand"
							[(ngModel)]="brand"
							[ngClass]="editMode ? 'select-disabled' : ''"
							(selectionChange)="onBrandChange($event)"
							[disabled]="editMode">
							<mat-option [value]="undefined">All Brands</mat-option>
							@for (brand of brands.data; track brand.brandId) {
							<mat-option [value]="brand">{{ brand.brandName }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="flex-1 flex column">
					<span class="bold margin-bottom-small">Category</span>
					<mat-form-field appearance="outline">
						<mat-select
							name="category"
							[(ngModel)]="category"
							(selectionChange)="getCategoryStyles(0)"
							[disabled]="editMode"
							[ngClass]="editMode ? 'select-disabled' : ''">
							<mat-option [value]="undefined">All Categories</mat-option>
							@for (category of categories.data; track category.id) {
							<mat-option [value]="category">{{ category.name }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
			</div>

			<div class="flex center margin-top">
				<div class="flex-1 flex column margin-right-small">
					<span class="bold margin-bottom-small">Styles</span>
					<mat-form-field appearance="outline">
						<mat-select
							name="styles"
							[(ngModel)]="stylesSelected"
							(selectionChange)="getColorsByModel()"
							[disabled]="!category || editMode"
							[ngClass]="!category || editMode ? 'select-disabled' : ''"
							multiple>
							@for (style of styles.data; track style.modelId) {
							<mat-option [value]="style">{{ style.fullName }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="flex-1 flex column">
					<span class="bold margin-bottom-small">Colors</span>
					<mat-form-field appearance="outline">
						<mat-select
							name="colors"
							[(ngModel)]="colorsSelected"
							[disabled]="stylesSelected.length !== 1 || editMode"
							[ngClass]="stylesSelected.length !== 1 || editMode ? 'select-disabled' : ''"
							multiple>
							@for (color of colors.data; track color.colorId) {
							<mat-option [value]="color">{{ color.fullName }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
			</div>
		</div>

		<div class="flex center column margin-top margin-bottom">
			<i class="fa-solid fa-arrow-down big primary"></i>
		</div>

		@if (brand?.hasSizeGroup) {
		<div class="flex column margin-bottom">
			<span class="bold margin-bottom-small">Shots options:</span>
			<mat-slide-toggle [(ngModel)]="differentShotsForSizeGroups" (change)="onDifferentShotsForSizeGroups()">
				Different shot types for size groups
				<i>(Available only for K-Way)</i>
			</mat-slide-toggle>
		</div>
		}

		<span class="bold">Shots:</span>
		<div class="padding border margin-top-small">
			<div class="flex between end">
				<div class="grey">{{ shoots.length }} shots</div>
				<div class="flex center">
					<button (click)="addShot()">
						<i class="fa-solid fa-add"></i>
						Add Shot
					</button>
				</div>
			</div>

			@if (!shoots.length) {
			<div class="margin-top bg-light-grey padding-large flex center column">
				<div class="flex column grey center">
					<i class="fa-solid fa-add big margin-bottom-smallest"></i>
					Add shots
				</div>
			</div>
			} @else {
			<div class="grid margin-top">
				<span class="bold">Type</span>
				<span class="bold">Media Format</span>
				<span class="bold">Aspect Ratio</span>
				<span class="bold">Utilizzo Codificato</span>
				<span class="bold">Action</span>

				@for (shot of shoots; track shot; let i = $index) { @if (shot.sizeGroupName) {
				<span class="bold row margin-top-small primary">{{ shot.sizeGroupName }}</span>
				}

				<!-- Shot Type -->
				<mat-form-field appearance="outline">
					<mat-select name="shotType" (selectionChange)="selectShotType($event, i)" [value]="shot.shotTypeId">
						@for (shotType of shotTypes.data; track shotType.id) {
						<mat-option [disabled]="isShotTypeSelected(shotType.id, i)" [value]="shotType.id">
							{{ shotType.code }} - {{ shotType.name }}
						</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<!-- Media Format -->
				<mat-form-field appearance="outline">
					<mat-select name="mediaFormat" (selectionChange)="selectMediaFormat($event, i)" [value]="shot.mediaFormatId">
						@for (mediaFormat of mediaTypes.data; track mediaFormat.id) {
						<mat-option [value]="mediaFormat.id">{{ mediaFormat.code }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<!-- Aspect Ratio -->
				<mat-form-field appearance="outline">
					<mat-select name="aspectRatio" (selectionChange)="selectAspectRatio($event, i)" [value]="shot.aspectRatioId">
						@for (aspectRatio of aspectRatios.data; track aspectRatio.id) {
						<mat-option [value]="aspectRatio.id">{{ aspectRatio.code }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<!-- Utilizzo Codificato -->
				<mat-form-field appearance="outline">
					<mat-select
						name="codifiedUsed"
						[disabled]="!shotCombinations.length"
						(selectionChange)="selectCodifiedUsed($event, i)"
						[value]="shot.codifiedUsedId">
						@for (codifiedUsed of codifiedUseds.data; track codifiedUsed.id) {
						<mat-option [disabled]="isCodifiedUsedSelected(codifiedUsed.id, i)" [value]="codifiedUsed.id">
							{{ codifiedUsed.code }} - {{ codifiedUsed.description }}
						</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<div class="flex center">
					<span class="flex center red hover nowrap" (click)="removeShot(i)">
						<i class="fa-solid fa-trash margin-right-small"></i>
						Remove
					</span>
				</div>
				}
			</div>

			@if (differentShotsForSizeGroups) {
			<div class="margin-top">Add size group</div>
			<div class="flex center margin-top-small">
				<div class="margin-right-small">
					<mat-form-field appearance="outline">
						<mat-select name="sizeGroup" [(ngModel)]="sizeGroups.selected" [disabled]="!sizeGroups.data">
							@for (sizeGroup of sizeGroups.data; track sizeGroup.id) {
							<mat-option [value]="sizeGroup">{{ sizeGroup.name }}</mat-option>
							} @empty {
							<mat-option disabled>
								<div class="margin">No available size groups</div>
							</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="flex-0">
					<button [disabled]="!sizeGroups.selected" (click)="addSizeGroup()">
						<i class="fa-solid fa-add"></i>
						Add
					</button>
				</div>
			</div>
			} }
		</div>
	</form>
</div>
